import countMapUrl from "../pages/index/components/userCodeUrl";
const user = {
    state:{
      user:"",
      urlList:""
    },
    mutations:{
      USER_INFO(state,info){
        state.user = info
      },
      URLLIST_INFO(state,info){
        state.urlList = info
      }
    },
    actions:{
      saveUserInfo({ commit },data){
        // 用户数据
        commit('USER_INFO',data)
        const user = data
        let urlObjdct = countMapUrl.find((value) => {
          if (user.troopsType == value.troopsType) return value
        })
        // 用户请求接口
        commit('URLLIST_INFO',urlObjdct)
      },
      saveUrlListInfo({ commit },data){
        commit('URLLIST_INFO',data)
      }
    }
  };
  export default user


// WEBPACK FOOTER //
// ./src/store/user.js